/* eslint-disable */

import APIENDPOINTS from '../constants/apiconstants';
import APICALLER from '../helper/APICALLER';
import { API } from '../helper/requests';
import { routeToLogin } from '../helper/utils';
import { LOGIN_RESP_MOCK } from '../client/__mock__/appmock';

export const performAuthorization = async (setLoading, setUserProfile) => {
	try {
		// Local development
		if (process.env.NODE_ENV === 'development') {
			localStorage.setItem('PORTAL_CONTEXT', JSON.stringify(LOGIN_RESP_MOCK));
			setUserProfile(LOGIN_RESP_MOCK);
			setLoading(false);
		} else {
			// Build DEV/QA/PROD
			const portalResp = await APICALLER(APIENDPOINTS.PORTAL_USER_INFO);
			if (
				portalResp?.error?.response?.status === API.RESPONSE.UNAUTHORIZED ||
				portalResp?.error
			) {
				routeToLogin();
			} else if (portalResp?.status === API.RESPONSE.SUCCESS) {
				const responseData = portalResp?.data;
				localStorage.setItem('PORTAL_CONTEXT', JSON.stringify(responseData));
				setUserProfile(responseData);
			}
			setLoading(false);
		}
	} catch (e) {
		setLoading(false);
		routeToLogin();
	}
};
